module.exports = __webpack_public_path__ + "media/categories/1508-64a9fe49.png";